import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Loader } from '../Loader';
import { LoaderBar } from '../Loader/LoaderBar';
const AnimationWrapper = styled.div.withConfig({
  displayName: "PrintProgressLoader__AnimationWrapper",
  componentId: "sc-1dg54zy-0"
})([".progress-enter{animation-duration:0.3s;animation-name:ease-in-bottom;}@keyframes ease-in-bottom{from{translate:0 -5vh;opacity:0.75;}to{translate:0 0;opacity:1;}}.progress-exit{animation-name:ease-out-top;animation-duration:0.3s;}@keyframes ease-out-top{from{translate:0 0;opacity:0.75;}to{translate:0 -10vh;opacity:0;}}"]);
const ModalLayoutDiv = styled.div.withConfig({
  displayName: "PrintProgressLoader__ModalLayoutDiv",
  componentId: "sc-1dg54zy-1"
})(["position:absolute;width:100%;height:100%;display:flex;flex-direction:row;justify-content:center;align-items:center;z-index:1400;"]);
const ModalDiv = styled.div.withConfig({
  displayName: "PrintProgressLoader__ModalDiv",
  componentId: "sc-1dg54zy-2"
})(["width:65vw;height:30vh;min-height:200px;max-height:400px;background-color:var(--mumms-paper);border:4px solid black;border-radius:1vw;@media only screen and (max-device-width:1112px){max-height:300px;}"]);
const LayoutWrapper = styled.div.withConfig({
  displayName: "PrintProgressLoader__LayoutWrapper",
  componentId: "sc-1dg54zy-3"
})(["width:100%;height:90%;display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
const TitleWrapper = styled.div.withConfig({
  displayName: "PrintProgressLoader__TitleWrapper",
  componentId: "sc-1dg54zy-4"
})(["padding-bottom:2vh;display:flex;flex-direction:row;justify-content:center;align-items:center;gap:10px;width:80%;"]);
const MummsLogo = /*#__PURE__*/React.createElement("img", {
  src: `${process.env.PUBLIC_URL}/assets/logo-512.png`,
  alt: "mumms-logo",
  width: "40vw"
});
const withStyles = makeStyles(theme => ({
  text: {
    color: theme.palette.text.primary
  }
}));

var _ref = /*#__PURE__*/React.createElement("div", null, MummsLogo);

var _ref2 = /*#__PURE__*/React.createElement(Loader, null);

export const PrintProgressLoader = ({
  progress,
  sourceString
}) => {
  const [animationClass, setAnimationClass] = useState('progress-enter');
  const classes = withStyles();
  const complete = progress && progress.percent === 1;
  const loading = animationClass !== '';
  const renderModal = progress !== null && (!complete || loading);
  useEffect(() => {
    setAnimationClass('progress-enter');
    setTimeout(() => {
      setAnimationClass('');
    }, 300);
  }, []);
  return /*#__PURE__*/React.createElement(AnimationWrapper, null, progress && renderModal ? /*#__PURE__*/React.createElement(ModalLayoutDiv, {
    className: animationClass
  }, /*#__PURE__*/React.createElement(ModalDiv, null, /*#__PURE__*/React.createElement(LayoutWrapper, null, /*#__PURE__*/React.createElement(TitleWrapper, null, _ref, /*#__PURE__*/React.createElement("div", {
    className: classes.text,
    style: {
      fontSize: '2rem',
      fontWeight: 'bold'
    }
  }, sourceString)), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '40vw'
    }
  }, /*#__PURE__*/React.createElement(LoaderBar, {
    value: progress.percent
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.text,
    style: {
      paddingTop: '1vh',
      fontSize: '1.1rem'
    }
  }, progress.message)))) : _ref2);
};